require('./style.css');
var tmpl = require('./main.ejs');

var Ready = function (time) {
  this.time = time;
  this.init();
};

Ready.prototype.init = function () {
  this.initDom();
  this.initEvent();
};

Ready.prototype.initDom = function () {
  var div = document.createElement('div');
  div.innerHTML = tmpl();
  this.el = div.children[0];
  this.elReady = this.el.querySelector('.c-ready');

  if (this.time) {
    this.elReady.innerHTML = time + ' 准时开播';
  } else {
    this.elReady.innerHTML = '直播即将开始，请耐心等待';
  }
};

Ready.prototype.initEvent = function () {
};

Ready.prototype.hide = function () {
  this.el.style.display = 'none';
};

Ready.prototype.show = function () {
  this.el.style.display = 'flex';
};

Ready.prototype.renderTo = function (parentNode) {
  parentNode.appendChild(this.el);
};

Ready.prototype.destory = function () {
  this.el.parentNode.removeChild(this.el);
};


module.exports = Ready;


// WEBPACK FOOTER //
// /Users/gebb/Desktop/live/modules/f.compenont.video.mobile/app/modules/ready/index.js